import { errorType, errorMessage } from 'models/errors';
import { isNil } from 'swipeclock-frontend';

// Default error that is returned under protoype Error
// This is great except when dealing with errors in redux
// It will throw a "non-serializable value detected..."
export function DefaultError(
  message = errorMessage.default,
  type = errorType.default
) {
  this.name = type;
  this.message = message;
}
DefaultError.prototype = Object.create(Error.prototype);

// Easy method to return a serializable object that
// can act like an error
export function getError(
  message = errorMessage.default,
  type = errorType.default
) {
  return { message, type };
}

// Helper to convert class based errors into
// a serializable error
export function getSerializableError(error) {
  if (isNil(error)) {
    return getError();
  }
  return getError(error?.message, error?.name);
}

export function createErrorNotification(error) {
  console.log('Show Error now', error);
  const response = (error || {}).response;
  const errorCode = (response || {}).status;
  console.log('errorCode', response);
  const statusText = (response || {}).statusText || '';
  const message = ((response || {}).data || {}).Message;
  const errMessage = statusText
    ? `Error: ${errorCode} - ${statusText}`
    : `Error: ${errorCode}`;
  return {
    type: 'error',
    message: message ? `Error: ${message}` : errMessage,
    dismissable: true,
  };
}
